import { ConciergeContextData, requestConciergeContext } from './conciergeContext';

/**
 * Row 2675: the setting (CONCIERGE_REPORT_CONTEXT_CAPTURE, a page constant, off unless true) of whether the panel asks the report
 * it is on for its context (filters, selected marks or data points, slicers, parameters) and sends it with the question. The
 * report itself (the viewer path and element_id) is sent either way, so a question is routed the same at off and on.
 */
export const REPORT_CONTEXT_CAPTURE = 'CONCIERGE_REPORT_CONTEXT_CAPTURE';

/** The part of the store the setting is read from: the session configuration's page constants. */
type ConstantsState = { auth?: { configuration?: { constants?: Record<string, unknown> } } };

export function reportContextCaptureOn(state: ConstantsState): boolean {
    return state?.auth?.configuration?.constants?.[REPORT_CONTEXT_CAPTURE] === true;
}

/**
 * The context a question carries: the caller's own getContext, then every registered provider's, joined. At off neither is
 * asked (no wait on the report) and there is no context.
 */
export async function collectReportContext(
    captureOn: boolean,
    getContext?: () => unknown,
    request: () => Promise<ConciergeContextData | null> = requestConciergeContext,
): Promise<string | undefined> {
    if (!captureOn) {
        return undefined;
    }
    let externalContext: string | undefined;
    if (getContext) {
        try {
            const contextResult = await getContext();
            if (contextResult !== undefined && contextResult !== null) {
                externalContext = typeof contextResult === 'string' ? contextResult : JSON.stringify(contextResult);
            }
        } catch (e) {
            console.error('Error calling getContext callback:', e);
        }
    }

    const conciergeContext = await request();
    if (conciergeContext) {
        const conciergeContextStr = JSON.stringify(conciergeContext);
        externalContext = externalContext ? `${externalContext}\n\n${conciergeContextStr}` : conciergeContextStr;
    }

    return externalContext;
}
